export interface StrapiDynamicZoneComponentDTO {
    __component: string;
}

export class DynamicZoneComponentDTO {
    constructor() { }

    __component: string;

    static async fromStrapi(locale: string, strapiData?: StrapiDynamicZoneComponentDTO): Promise<DynamicZoneComponentDTO> {
        if (!strapiData) {
            return null;
        }

        const dynamicZoneComponent = new DynamicZoneComponentDTO();
        dynamicZoneComponent.__component = strapiData.__component;
        return dynamicZoneComponent;
    }
}
